import { render } from "./Stories.vue?vue&type=template&id=8cb52c80&scoped=true"
import script from "./Stories.vue?vue&type=script&lang=js"
export * from "./Stories.vue?vue&type=script&lang=js"

import "./Stories.vue?vue&type=style&index=0&id=8cb52c80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cb52c80"]])

export default __exports__